import { Head } from '@inertiajs/react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { AdminArcadeChallengesIndex } from '@/types';
import { ArcadeChallengesTable } from './components/ArcadeChallengesTable';
import { CreateArcadeChallengeDialog } from './components/CreateArcadeChallengeDialog';

export default function Index({
  title,
  challenges,
  events,
}: AdminArcadeChallengesIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="font-bold text-3xl tracking-tight">
              Arcade Challenges
            </h1>
            <p className="text-muted-foreground">
              Manage challenge windows and event assignments for the arcade.
            </p>
          </div>
          <CreateArcadeChallengeDialog events={events} />
        </div>

        <Card>
          <CardHeader>
            <CardTitle>All Arcade Challenges ({challenges.length})</CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <ArcadeChallengesTable challenges={challenges} events={events} />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
